import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { usePilotContext } from '../hooks/usePilotContext';

export default function SimulationPage() {
  const { context } = usePilotContext();
  const [attackTypes, setAttackTypes] = useState('');
  const [job, setJob] = useState(null);
  const [running, setRunning] = useState(false);

  const start = async () => {
    setRunning(true);
    try {
      const types = attackTypes.split(',').map((s) => s.trim()).filter(Boolean);
      const res = await api.post('/api/resimulate', {
        customer_id: context.customer_id,
        attack_types: types.length ? types : undefined,
        scenario_name: 'pilot-resim',
      });
      setJob(res);
      toast.success('Re-simulation job queued');
    } catch (e) {
      toast.error(e.message || 'Could not start re-simulation');
    } finally {
      setRunning(false);
    }
  };

  const refresh = async () => {
    if (!job?.resim_id) return;
    try {
      const data = await api.get(`/api/resimulate/${job.resim_id}`);
      setJob(data);
    } catch (e) {
      toast.error(e.message || 'Could not refresh job');
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold text-foreground">Resimulation</h1>
        <p className="text-muted-foreground">Queue and monitor replay jobs for selected attack types.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Start Re-simulation</CardTitle>
          <CardDescription>Enter comma-separated attack types (optional).</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input value={attackTypes} onChange={(e) => setAttackTypes(e.target.value)} placeholder="example: credential_theft,lateral_movement" />
          <Button onClick={start} disabled={running}>{running ? 'Submitting...' : 'Start job'}</Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Job Status</CardTitle>
              <CardDescription>{job?.resim_id || 'No job submitted yet'}</CardDescription>
            </div>
            <Button size="sm" variant="outline" onClick={refresh} disabled={!job?.resim_id}><RefreshCw className="mr-1 h-4 w-4" />Refresh</Button>
          </div>
        </CardHeader>
        <CardContent>
          {!job ? <p className="text-sm text-muted-foreground">Submit a job first.</p> : <pre className="overflow-x-auto rounded-md bg-secondary/40 p-3 text-xs">{JSON.stringify(job, null, 2)}</pre>}
        </CardContent>
      </Card>
    </div>
  );
}
